import { Box, Stack, SxProps, Theme, Typography } from "@mui/material";
import CardSlider from "@/components/common/cardSlider/cardSlider";
import StyledCircleOverlay from "@/components/common/styledCircleOverlay/styledCircleOverlay";
import { INDIGO, TEXT_SECONDARY } from "@/config/mui/colorPalette";
import AffirmPromotionCard from "./paymentPlansSliderCard/affirmPromotionCard";
import CherryPromotionCard from "./paymentPlansSliderCard/cherryPromotionCard";
import LearnMoreCard from "./paymentPlansSliderCard/learnMoreCard";

type ExplorePaymentPlansSliderProps = {
  clientId: string;
  medspaId: string;
  cherryPromotionEnabled: boolean;
  affirmPromotionEnabled: boolean;
  cherryApplicationLink: string;
  sx?: SxProps<Theme>;
};

export default function ExplorePaymentPlansSlider({
  clientId,
  medspaId,
  cherryPromotionEnabled,
  affirmPromotionEnabled,
  cherryApplicationLink,
  sx,
}: ExplorePaymentPlansSliderProps) {
  if (!cherryPromotionEnabled && !affirmPromotionEnabled) return null;

  const cards = [
    cherryPromotionEnabled && {
      id: "cherry-plan-card",
      content: (
        <CherryPromotionCard
          clientId={clientId}
          medspaId={medspaId}
          cherryApplicationLink={cherryApplicationLink}
        />
      ),
    },
    affirmPromotionEnabled && {
      id: "affirm-plan-card",
      content: <AffirmPromotionCard clientId={clientId} medspaId={medspaId} />,
    },
    {
      id: "learn-more-card",
      content: <LearnMoreCard clientId={clientId} medspaId={medspaId} />,
    },
  ].filter(Boolean);

  const getDescription = () => {
    if (cherryPromotionEnabled && affirmPromotionEnabled) {
      return "We partner with Cherry and Affirm - get what you need now, pay later!";
    }
    if (cherryPromotionEnabled) {
      return "We partner with Cherry - get what you need now, pay later!";
    }

    return "We partner with Affirm - get what you need now, pay later!";
  };

  return (
    <Box
      sx={{
        p: 2,
        overflow: "hidden",
        position: "relative",
        borderRadius: 4,
        backgroundColor: INDIGO[20],
        ...sx,
      }}
    >
      <Stack sx={{ zIndex: 1000, gap: 1 }}>
        <Typography variant="h2" sx={{ zIndex: "inherit" }}>
          Explore flexible payment plans
        </Typography>
        <Typography
          color={TEXT_SECONDARY}
          variant="paragraphSmall"
          sx={{ zIndex: "inherit" }}
        >
          {getDescription()}
        </Typography>
        <CardSlider
          cards={cards}
          primaryColor={INDIGO[80]}
          style={{ padding: "16px 0" }}
        />
      </Stack>
      <StyledCircleOverlay color={INDIGO[80]} />
    </Box>
  );
}
